import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { rootActions } from "../../actions/rootActions";
import {
  eAccQuyDoiTyGiaActionIds,
  IAccQuyDoiTyGiaActionTypes,
} from "../../action-types/category/IAccQuyDoiTyGiaActions";
import { IAccQuyDoiTyGia } from "../../../model/respone/category/IAccQuyDoiTyGia";
import { quyDoiTyGiaApi } from "../../../api/category/quyDoiTyGiaApi";

export function* quyDoiTyGiaSaga(): any {
  yield takeLatest(eAccQuyDoiTyGiaActionIds.LOAD_START, loadWorker);
  yield takeEvery(eAccQuyDoiTyGiaActionIds.SAVE_START, saveWorker);
  yield takeEvery(eAccQuyDoiTyGiaActionIds.DELETE_START, deleteWorker);
}

function* loadWorker(): any {
  const res: IBaseRespone = yield call(quyDoiTyGiaApi.SelectAll);
  if (res.is_success) {
    yield put(rootActions.category.quyDoiTyGia.LOAD_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.category.quyDoiTyGia.LOAD_ERRR(res.message ?? "Có lỗi"),
    );
  }
}
function* saveWorker(action: IAccQuyDoiTyGiaActionTypes): any {
  let res: IBaseRespone;
  const payload = action.payload as IAccQuyDoiTyGia;
  if (payload.id > 0) {
    res = yield call(quyDoiTyGiaApi.Update, payload);
  } else {
    res = yield call(quyDoiTyGiaApi.Insert, payload);
  }
  if (res) {
    if (res.is_success) {
      yield put(rootActions.category.quyDoiTyGia.SAVE_SUCCESS(res.data));
    } else {
      yield put(
        rootActions.category.quyDoiTyGia.SAVE_ERROR(res.message ?? "Có lỗi"),
      );
    }
  }
}

function* deleteWorker(action: IAccQuyDoiTyGiaActionTypes): any {
  const res: IBaseRespone = yield call(
    quyDoiTyGiaApi.Delete,
    action.payload as number,
  );
  if (res.is_success) {
    yield put(rootActions.category.quyDoiTyGia.DELETE_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.category.quyDoiTyGia.DELETE_ERROR(res.message ?? "Có lỗi"),
    );
  }
}
